import {differenceInMinutes, parseISO} from 'date-fns';

import {isNil} from 'ramda';
import {isNotNilOrEmpty} from 'ramda-adjunct';

import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

type TimeToFirstResponse = {
  timeToFirstResponse?: string;
  days?: number | null;
  hours?: number | null;
  minutes?: number | null;
  hasEnded?: boolean;
};

export const getTimeToFirstResponse = <T extends {createdAt?: string | Nullish}>(
  data: T | Nullish,
  firstResponseAt: string | Nullish
): TimeToFirstResponse => {
  if (isNil(data)) {
    return {};
  }
  const now = new Date();

  const createdDate = data?.createdAt ? parseISO(data.createdAt) : null;

  const diffInMinutes = createdDate
    ? differenceInMinutes(firstResponseAt ?? now, createdDate)
    : null;

  const days = isNotNilOrEmpty(diffInMinutes) ? Math.floor(diffInMinutes! / (60 * 24)) : null;
  const hours = isNotNilOrEmpty(diffInMinutes)
    ? Math.floor((diffInMinutes! % (60 * 24)) / 60)
    : null;
  const minutes = isNotNilOrEmpty(diffInMinutes) ? diffInMinutes! % 60 : null;

  const timeToFirstResponse = [
    // we don't want to show 0 values, but 0m is ok
    days ? days + i18n.t('general.labels.dayCompact') : null,
    hours ? hours + i18n.t('general.labels.hourCompact') : null,
    isNotNilOrEmpty(minutes) ? minutes! + i18n.t('general.labels.minuteCompact') : null,
  ]
    .filter(Boolean)
    .join(' ');

  return {timeToFirstResponse, days, hours, minutes, hasEnded: isNotNilOrEmpty(firstResponseAt)};
};
